// extracted by mini-css-extract-plugin
export default {"hint":"styles_hint__FDjtR","vibrate":"styles_vibrate__Cy0Jy","scaleAndVibrate":"styles_scaleAndVibrate__Voe7C","content":"styles_content__0AH0Z","icon":"styles_icon__ICzb6"};